import { useMemo } from "react";
import { CancelModalFlowStepEnum } from "@hopper-b2b/types";

export enum CarCancellationView {
  Success = "success",
  Error = "error",
  Policy = "policy",
  Support = "support",
}

export const useCarCancellationView = ({
  cancelFlowStep,
}: {
  cancelFlowStep: CancelModalFlowStepEnum;
}) => {
  const carCancellationView = useMemo(() => {
    switch (cancelFlowStep) {
      case CancelModalFlowStepEnum.nonRefundable:
      case CancelModalFlowStepEnum.policy:
      case CancelModalFlowStepEnum.confirm: {
        return CarCancellationView.Policy;
      }

      case CancelModalFlowStepEnum.cancelled:
      case CancelModalFlowStepEnum.success:
        return CarCancellationView.Success;

      // The quote loaded but the booking can't be cancelled via self-serve
      // (contact customer service, already cancelled, pending, pickup in the
      // past). Show the scenario copy with a contact-support CTA rather than
      // the generic "unable to process" error with a retry button.
      case CancelModalFlowStepEnum.support:
        return CarCancellationView.Support;

      case CancelModalFlowStepEnum.tenantError:
      case CancelModalFlowStepEnum.error:
      case CancelModalFlowStepEnum.tryAgain:
        return CarCancellationView.Error;

      default:
        return undefined;
    }
  }, [cancelFlowStep]);

  return {
    carCancellationView,
  };
};
